/** @jsx jsx */
import { css, jsx, useTheme } from "@emotion/react";
import { navigate } from "gatsby";
import PropTypes from "prop-types";

import { useThemeProps, Icon } from "../../../wsui/base";

HeaderSearchField.propTypes = {
  menuName: PropTypes.string,
  color: PropTypes.string,
  resultType: PropTypes.string,
};

export default function HeaderSearchField(props) {
  const theme = useTheme();
  props = useThemeProps({ name: "HeaderSearchField", props });
  let { resultType, ...restProps } = props;

  return (
    <form
      method="GET"
      action={resultType ? `/${resultType}` : "/sok"}
      onSubmit={(event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        navigate(`/${resultType || "sok"}?query=${formData.get("query")}`);
      }}
      css={css``}
      {...restProps}
    >
      <label
        htmlFor="site-search"
        css={css`
          position: absolute;
          clip: rect(0, 0, 0, 0);
          pointer-events: none;
        `}
      >
        Sök
      </label>
      <div
        css={css`
          position: relative;
          display: grid;
          align-items: center;
          & > * {
            grid-column: 1;
            grid-row: 1;
            font-family: Hellix;
          }
        `}
      >
        <Icon
          name="search"
          size="1.8rem"
          css={css`
            pointer-events: none;
            margin-left: 1.25rem;
            color: ${theme.getColor("aubergine")};
          `}
        />
        <input
          id="site-search"
          type="search"
          name="query"
          placeholder="Sök"
          autoComplete="off"
          css={css`
            padding: 1rem 2rem 1rem 3.7rem;
            background-color: ${theme.getColor("white")};
            width: 100%;
            border: none;
            border-radius: 6px;
            font-size: ${theme.getLength(4)};

            &::placeholder {
              color: ${theme.getColor("aubergine")};
            }
          `}
        />
      </div>
      <button
        type="submit"
        css={css`
          position: absolute;
          clip: rect(0, 0, 0, 0);
          pointer-events: none;
        `}
      >
        Sök
      </button>
    </form>
  );
}
